import type { BaseQueryFn } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import type { AxiosRequestConfig, AxiosError } from "axios";
import isAuthenticated from "../common/isAuthenticated";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { logout } from "./slices/profile";
import { store } from "../app/store";

const axiosBaseQuery =
    (
        { baseUrl }: { baseUrl?: string } = {
            baseUrl: import.meta.env.VITE_APP_API_KEY
        },
    ): BaseQueryFn<
        {
            url: string;
            method: AxiosRequestConfig["method"];
            data?: AxiosRequestConfig["data"];
            params?: AxiosRequestConfig["params"];
            headers?: AxiosRequestConfig['headers'];
            

        },
        unknown,
        unknown
    > =>
        async ({ url, method, data, params, headers }) => {
            try {
                const result = await axios({
                    url: baseUrl + url, method, data, params, headers: {
                        // Add any common headers here
                        'Authorization': `Bearer ${store.getState().profile.token}`,
                        'Content-Type': 'application/json',
                        ...headers,
                    },
                });
                return { data: result.data };
            } catch (axiosError) {
                let err = axiosError as AxiosError;
                if (err.response?.status === 401) {
                    // window.location.href = "/";
                    throw "oops Error"
                }
                return {
                    error: {
                        status: err.response?.status,
                        data: err.response?.data || err.message,
                    },
                };
            }
        };


export default axiosBaseQuery;
